module.exports = __webpack_public_path__ + "img/timeline.e10fb6f3.jpg";